






















































































































































import {
  Prop,
  Vue,
  Component,
  Watch
} from "@/shared/vuepack";
import {
  FetchState,
  LoginMethod,
} from "@/shared/types";
import { Validator } from "vee-validate";
import { ErrorsMixin } from "@/employer/components/shared/ErrorsMixin";
import { mixins } from "vue-class-component";
import moment from "moment";
import Input from "@/shared/components/ui/Input.vue";
import Checkbox from "@/shared/components/ui/Checkbox.vue";
import Button from "@/shared/components/ui/Button.vue";
import * as _ from "lodash";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useNotifierStore } from "@/shared/store/notifier";
import { useEnrollmentStore } from "@/employee/store/enrollment";
import { useUserStore } from "@/shared/store/user";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import user from "@/shared/resource/user";

@Component({
  computed: {
    user () {
      return user;
    }
  },
  components: {
    Input,
    Checkbox,
    Button,
    LoginWrapper,
    GenericLoadingSpinner
  }
})
export default class ClaimAccount extends mixins(ErrorsMixin) {
  @Prop() routeToDashboard;
  @Prop() c: string;
  @Prop() routeToLogin;

  enrollmentStore = useEnrollmentStore();
  userStore = useUserStore();
  portalCustomizationStore = usePortalCustomizationStore();
  notifierStore = useNotifierStore();

  $validator: Validator;

  email = "";
  isEmailDirty = false;
  awaitLogin = false;
  dateOfBirth = "";
  last4Social = "";
  confirmPassword = "";
  password = "";
  verification = "";
  showLoginSpinner = false;

  get isLoaded () {
    return this.enrollmentStore.isLoaded && this.portalCustomizationStore.isSupportInfoLoaded;
  }

  get partnerName () {
    return this.portalCustomizationStore.supportInfo.displayName;
  }

  @Watch("enrollmentStore.isEnrolled")
  @Watch("enrollmentStore.isClaimed")
  onEnrollmentOrClaimStateChange () {
    if (this.awaitLogin) {
      this.showLoginSpinner = true;
      this.userStore.setLoginMethod(LoginMethod.DirectLogin);
      this.userStore.login({ username: this.email, password: this.password, logoutOnStart: true, delayAfterLogout: true });
      return;
    }
    if (this.enrollmentStore.wasClaimedAlready) {
      this.$router.push(this.routeToLogin);
      return;
    }
    if (this.enrollmentStore.isEnrolled || this.enrollmentStore.isClaimed) {
      this.$router.push(this.routeToDashboard);
      return;
    }
  }

  @Watch("enrollmentStore.email")
  onEmailStateChange () {
    this.email = this.enrollmentStore.email;
  }

  @Watch("proposedEmail")
  watchProposedEmail (emailValue) {
    this.debouncedCheckEmailAvailability(emailValue);
  }

  @Watch("userStore.loggedIn")
  watchLoggedIn (isLoggedIn) {
    if (isLoggedIn && this.awaitLogin) {
      this.$router.push(this.routeToDashboard);
      // todo: ^^^ send user to wizard
    }
  }

  @Watch("enrollmentStore.emailVerify")
  watchEmailVerify (newValue) {
    if (this.isSubmitting && newValue) {
      this.isSubmitting = false;
    }
  }

  debouncedCheckEmailAvailability = _.debounce(emailString => this.enrollmentStore.checkEmailAvailability(emailString),
      1000);

  mounted () {
    const claimLinkId: string = this.c || "";

    if (!claimLinkId) {
      this.notifierStore.setDanger("Sorry this link is invalid");
      return;
    }

    this.enrollmentStore.enrollmentStatusFromClaim(claimLinkId);
  }

  get hasValidEmail () {
    return this.email !== "" && !this.$validator.errors.has("email");
  }

  get showLoginLink () {
    return !this.userStore.loggedIn && !this.enrollmentStore.isEmailConfirming
        && this.hasValidEmail && !this.enrollmentStore.isEmailAvailabilityConfirmed && !this.enrollmentStore.isEnrollmentDisabled;
  }

  get isVisible () {
    return this.enrollmentStore.fetchState === FetchState.Loaded;
  }

  get proposedEmail () {
    return (!this.userStore.loggedIn && this.hasValidEmail) ? this.email : "";
  }

  get isNextButtonDisabled () {
    return this.$validator.errors.any() || this.isSubmitting ||
        (this.userStore.loggedIn === false && !this.enrollmentStore.isEmailAvailabilityConfirmed);
  }

  get isCheckingEmail () {
    return this.hasValidEmail && this.enrollmentStore.isEmailConfirming;
  }

  get confirmPasswordValidation () {
    return {
      required: !!this.password,
      confirmed: !!this.confirmPassword && this.password
    };
  }

  get FormattedVerification (): string {
    return this.verification.replace(/\s/g, "");
  }

  onSubmit () {
    if (this.isSubmitting || this.enrollmentStore.isEnrollmentDisabled) {
      return;
    }

    this.$validator.validateAll()
        .then(result => {
          if (!result) {
            return;
          }

          this.awaitLogin = !this.userStore.loggedIn;
          this.isSubmitting = true;

          this.enrollmentStore.claimUserAccountBegin({
                claimCode: this.c,

                email: this.email,
                last4Ssn: this.last4Social,
                dateOfBirth: moment(this.dateOfBirth).format("YYYY-MM-DD"),
                password: this.password
              })
              .catch(this.handleError);
        });
  }

  onSubmitVerification () {
    this.$validator.validateAll().then(result => {
      if (!result) {
        return;
      }

      this.isSubmitting = true;

      this.enrollmentStore.claimUserAccountEnd(this.FormattedVerification).catch(this.handleError);
    });
  }
}
